import React from "react";
import SsingleSelect from "./SSingleSelect";

const SimpleSelect = (props) => {
  return (
    <>
      {props.required ? (
        <select
          className="form-control"
          onChange={(e) => props.onChange(e)}
          value={props.value ? props.value : ""}
          name={props.name ? props.name : ""}
          required={props.required ? true : false}
          disabled={props.disabled ? props.disabled : false}
        >
          <option value="">{props.init ? props.init : "Select"}</option>
          {Array.isArray(props.options)
            ? props.options.map((data, index) => {
                return (
                  <option key={props.id} value={data[props.id ? props.id : "id"]}>
                    {data[props.label ? props.label : "label"]}
                  </option>
                );
              })
            : ""}
        </select>
      ) : (
        <SsingleSelect
          blankSelect={props.init ? props.init : "Select"}
          value={props.value}
          options={props.options}
          KEY_label={props.label ? props.label : "label"}
          KEY_value={props.id ? props.id : "id"}
          name={props.name ? props.name : ""}
          onChange={(e) => props.onChange(e)}
          disabled={props.disabled ? props.disabled : false}
          style={props.style ? props.style : {}}
          array={props.array}
          object={props.object}
          menuPortalTarget={props.menuPortalTarget}
        />
      )}
    </>
  );
};
export default SimpleSelect;
